import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PrestamosModel } from './prestamos.model';
import { PrestamosService } from './prestamos.service';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';
import { LoadingDialogService } from '../../../shared/ui/loading/loading-dialog.service';

@Component({
    selector: 'convfact-prestamos',
    templateUrl: './prestamos.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})

export class PrestamosComponent implements OnInit {

  public prestamos = new PrestamosModel;
  public spinner: boolean = false;
  public ready: boolean = false;

  constructor(
    private prestamosService: PrestamosService,
    private notify: NotificationService,
    private loading: LoadingDialogService,
    private router: Router
  ) { }

  public ngOnInit(): void {
    const temp = this.router.url.split('/');
    if (temp.length == 6) {
      const uid = temp[5];
      this.prestamosService.get(uid)
        .then(response => {
          if (!response) throw new Error();
          this.prestamos = response;
          this.ready = true;
        })
        .catch(() => {
          this.notify.error('No se pudo cargar el préstamo');
          this.returnToIndex();
        });
    }
    else {
      this.ready = true;
    }

  }

  public saveData(prestamos: PrestamosModel): void {
    if (this.spinner) return;
    this.spinner = true;

    const isNew = prestamos.uid == null;
    const request = isNew ? this.prestamosService.add(prestamos) : this.prestamosService.edit(prestamos);

    this.loading.run(isNew ? 'Creando préstamo…' : 'Guardando préstamo…', request)
      .then(() => {
        this.spinner = false;
        this.notify.ok(isNew ? 'Préstamo creado correctamente' : 'Préstamo actualizado correctamente');
        this.returnToIndex();
      })
      .catch(error => {
        this.spinner = false;
        const serverMessage = error && error.error && error.error.message;
        this.notify.error(isNew
          ? (serverMessage || 'Ha ocurrido un error inesperado al crear el préstamo')
          : 'Ha ocurrido un error inesperado al actualizar el préstamo');
      });
  }

  public returnToIndex(): void {
    this.router.navigate(['finance/loans']);
  }

}
